import { forwardRef } from 'react'

import { TableWrapper } from '../TableWrapper'
import type { SectionProps } from './Section'
import { Section } from './Section'

export const TableSection = forwardRef(
  ({ children, ...rest }: SectionProps, ref) => {
    return (
      <Section
        ref={ref}
        {...rest}
        wide
        cardHeaderProps={{
          zIndex: 1,
          boxShadow: 'xs',
          ...rest.cardHeaderProps,
        }}
        bodyProps={{ sx: { px: 0, pb: 0, pt: 0 } }}
      >
        <TableWrapper>{children}</TableWrapper>
      </Section>
    )
  },
)
